import React, { useEffect } from 'react';
import * as logger from '../utils/logger';
import * as messageInterceptor from '../utils/message-interceptor';
import { toMilliSeconds } from '../services/seek';
import { messages, inactivity } from '../constants';
import { useTranslation } from '../hooks/translate';
import pin from '../images/pin.svg';
import readyToCast from '../images/ready-to-cast.svg';
import styles from './ready-to-pin.css';
import stylesToCast from './ready-to-cast.css';

/**
 * Parental PIN view.
 */
export function ReadyToPin({ currentSchedule }) {
  const playerManager = cast.framework.CastReceiverContext.getInstance().getPlayerManager();
  const log = logger.create('ReadyToPin');
  const [translate] = useTranslation();

  useEffect(() => {
    log.info('Timeout after 3 min');

    const timeout = setTimeout(() => {
      messageInterceptor.broadcast(messages.expiredRequestPin);
      log.info('Requesting PIN timeout reached');
      playerManager.stop();
    }, toMilliSeconds(inactivity.parentalPin));

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div className={styles.main}>
      <img src={pin}></img>
      <p className={styles.title}>{translate('readyToPinTitle')}</p>
      <p className={stylesToCast.text}>
        {translate('readyToPinDescription', { title: currentSchedule.title })} <br />
        {currentSchedule.ageTitle}
      </p>
      <div className={stylesToCast.readyToCast}>
        <img src={readyToCast} />
        <span className={stylesToCast.text}>{translate('splashReady')}</span>
      </div>
    </div>
  );
}
